import React from 'react';
import ROUTES from '../routes';
import checkoutImg from '../components/registrationFlow/transitionBackgrounds/checkout.svg';
import personalInfoImg from '../components/registrationFlow/transitionBackgrounds/personal_info.svg';
import testCenterImg from '../components/registrationFlow/transitionBackgrounds/test_center.svg';
import uploadPhotoImg from '../components/registrationFlow/transitionBackgrounds/upload_photo.svg';

// TODO: maybe move to types
export interface RegistrationFlowStep {
    stepNumber: number;
    isVisibleInStepper: boolean;
    route: string;
    transitionImage: string;
    title: React.ReactNode;
}

const removeEssayAndSubject = import.meta.env.VITE_REMOVE_ESSAY_AND_SUBJECT;
export const REG_FLOW_TITLES = {
    STEPS: {
        PERSONAL: <>Enter Your Information</>,
        TEST_CENTER: (
            <>
                Select {!removeEssayAndSubject && 'Test, '}Date{removeEssayAndSubject ? ' ' : ','}
                {!removeEssayAndSubject && <br />}
                and Test Center
            </>
        ),
        PHOTO_UPLOAD: 'Upload Your Photo',
        PURCHASE: 'Check Out',
        PAYMENT_CONFIRMATION: 'Check Out',
        WAITLIST: 'Setting Up Waitlist',
    },
};

export const STEP_PERSONAL = 0;
export const STEP_TEST_CENTER_V2 = 1;
export const STEP_TEST_CENTER = 2;
export const STEP_PHOTO_UPLOAD = 3;
export const STEP_PURCHASE = 4;
export const STEP_PAYMENT_CONFIRMATION = 5;

export const registrationFlowSteps: RegistrationFlowStep[] = [
    {
        stepNumber: STEP_PERSONAL,
        isVisibleInStepper: true,
        route: ROUTES.personalInfo,
        transitionImage: personalInfoImg,
        title: REG_FLOW_TITLES.STEPS.PERSONAL,
    },
    {
        stepNumber: STEP_TEST_CENTER_V2,
        isVisibleInStepper: true,
        route: ROUTES.testCenterSearch,
        transitionImage: testCenterImg,
        title: REG_FLOW_TITLES.STEPS.TEST_CENTER,
    },
    {
        stepNumber: STEP_TEST_CENTER,
        // The legacy test center step shares a single stepper slot with STEP_TEST_CENTER_V2
        // (they are mutually exclusive via the `shouldShowTcSearchV2` toggle), so it is not
        // counted separately in the stepper. See getDisplayStep in stepUtils.
        isVisibleInStepper: false,
        route: ROUTES.testCenter,
        transitionImage: testCenterImg,
        title: REG_FLOW_TITLES.STEPS.TEST_CENTER,
    },
    {
        stepNumber: STEP_PHOTO_UPLOAD,
        isVisibleInStepper: true,
        route: ROUTES.photoUpload,
        transitionImage: uploadPhotoImg,
        title: REG_FLOW_TITLES.STEPS.PHOTO_UPLOAD,
    },
    {
        stepNumber: STEP_PURCHASE,
        isVisibleInStepper: true,
        route: ROUTES.purchase,
        transitionImage: checkoutImg,
        title: REG_FLOW_TITLES.STEPS.PURCHASE,
    },
    {
        stepNumber: STEP_PAYMENT_CONFIRMATION,
        isVisibleInStepper: false, // Payment confirmation is considered part of purchase for display.
        route: ROUTES.paymentConfirmation,
        transitionImage: checkoutImg, // On the off chance that the user navigates here directly, show it as part of purchase
        title: REG_FLOW_TITLES.STEPS.PURCHASE,
    },
];

export const SAT_REGISTRATION = 'SAT REGISTRATION';
// The number of steps to show in the stepper.
export const VISIBLE_STEP_COUNT = registrationFlowSteps.filter((step) => step.isVisibleInStepper).length;
